var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","min-height":"150px","border":"0"},attrs:{"src":`https://broadcaster.cloudsdaleradio.com/public/cloudsdale_radio/embed?theme=${_vm.theme}`,"frameborder":"0","allowtransparency":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }